import { useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { closeModal } from '../../../../../reducers/modalReducer';
import { clearSelectedPBProduct } from '../../../../../reducers/privateBankingReducer';
import { showToast } from '../../../../../reducers/toastReducer';
import { useErrorModal } from '../../../../../hooks/useErrorModal';
import {
  getServiceAgreementDetailsQueryKey,
  getServiceAgreementHistoryQueryKey,
} from '../../../../../hooks/queries/privateBanking';

export const useCloseProductOutcome = (brUid: string, serviceAgreementUid: string | undefined) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { showErrorModal } = useErrorModal();

  const onClosed = () => {
    void queryClient.invalidateQueries({ queryKey: ['eligiblePrivateBankingProducts', brUid] });
    if (serviceAgreementUid) {
      void queryClient.invalidateQueries({
        queryKey: getServiceAgreementDetailsQueryKey(serviceAgreementUid),
        refetchType: 'all',
      });
      void queryClient.invalidateQueries({
        queryKey: getServiceAgreementHistoryQueryKey(serviceAgreementUid),
        refetchType: 'all',
      });
    }
    dispatch(closeModal());
    dispatch(clearSelectedPBProduct());
    dispatch(
      showToast({
        type: 'success',
        position: 'top-center',
        titleText: t('pb.deleteproductmodal.success.message', 'Product closed successfully.'),
        dismissible: true,
        autoDismissDuration: 5000,
      }),
    );
  };

  const onCloseFailed = (error: unknown) => {
    dispatch(closeModal());
    showErrorModal(error, {
      title: t('pb.deleteproductmodal.error.title', 'Error while deleting'),
      userErrorMessage: t(
        'pb.deleteproductmodal.error.message',
        'An error occurred when closing the product. Please try again later.',
      ),
    });
  };

  return { onClosed, onCloseFailed };
};
